module.exports = __webpack_public_path__ + "static/y4420_17-c917dea6b69576f656fa5e4a13889a01.jpg";